const DeleteClub = ({ index, customers, deleteHandler }) => {
  const fun = (x) => {
    console.log("x", x);
  };
  return (
    <div
      className="modal fade"
      id={`exampleModalDelete`}
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      style={{ backgroundColor: "rgba(1,1,1,0.5)" }}
    >
      <div className="modal-dialog my-2">
        <div className="modal-content" style={{ minHeight: "auto" }}>
          <div className="modal-header" style={{ justifyContent: "end" }}>
            <h5 dir="ltr" className="modal-title" id="exampleModalLabel3">
              حذف تنظیمات
            </h5>
            <button
              type="button"
              className="btn btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>

          <div className="modal-body modlatrashposition">
            <p>آیا تنظیمات مد نظر حذف شود؟</p>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary btn-sm"
              data-bs-dismiss="modal"
            >
              خیر
            </button>
            <button
              type="button"
              onClick={() => {
                deleteHandler(customers[index].suppliers__id);
              }}
              className="btn btn-danger btn-sm"
              data-bs-dismiss="modal"
            >
              بله
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteClub;
